<template>
	<div class="nav">
		<div class="nav_con w-1440">
			<div class="nav_nr">
				<ul class="clear-fix">
					<li class="link" data-to="/index"><router-link to="/">
							<p>首页</p>
						</router-link></li>
					<li class="link" data-to="/policy"><router-link to="/policy">
							<p>政策法规</p>
						</router-link></li>


					<li class="link" data-to="/nongzi"><router-link to="/nongzi">
							<p>农资服务</p>
						</router-link></li>
					<li class="link" data-to="/nongji"><router-link to="/nongji">
							<p>农机服务</p>
						</router-link></li>

					<li class="link" data-to="/talent"><router-link to="/talent">
							<p>农技服务</p>
						</router-link></li>
					<li class="link" data-to="/financial"><router-link to="/financial">
							<p>金融服务</p>
						</router-link></li>
					<li class="link" data-to="/products"><router-link to="/products">
							<p>农产品</p>
						</router-link></li>
					<template v-if="guanli">
						<li class="link"><a
								href="http://www.myyehoo.com:96/login?username=admin&password=admin123#/index"
								target="_blank">
								<p>四情平台</p>
							</a></li>
					</template>
					<template v-else>
						<li class="link"><a href="http://www.myyehoo.com:96/login?username=test&password=test123#/index"
								target="_blank">
								<p>四情平台</p>
							</a></li>
					</template>


					<li class="link" data-to="/modern"><router-link to="/modern">
							<p>新型经营主体</p>
						</router-link></li>
					<li class="link" data-to="/aboutus"><router-link to="/aboutus">
							<p>关于我们</p>
						</router-link></li>
				</ul>

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "head_nav",
		data() {
			return {
				times: '',
				huanyingyu: '',
				guanli: false,
			}
		},
		mounted() {
			var token = window.localStorage.getItem('GAOYANGNONGYE_PC_ACCESS_TOKEN')
			if (token) {
				var token_time = window.localStorage.getItem('GAOYANGNONGYE_PC_ACCESS_TOKEN_TIME')
				if (token_time) {
					var date1 = new Date(token_time);
					var date2 = new Date();
					if (date1 > date2) {
						var userInfo = window.localStorage.getItem('GAOYANGNONGYE_PC_USERINFO')
						if (userInfo) {
							userInfo = JSON.parse(userInfo)
							if (userInfo.is_pingtai == 2) {
								this.guanli = true
							}
						}

					}
				}
			}

			this.setnav()
		},
		methods: {
			setnav() {
				var that = this;
				const url = location.href
				$('.link').each(function() {
					if (url.indexOf($(this).data('to')) != -1) {
						$(this).addClass('on')
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.nav {
		.nav_con {
			.nav_nr {

				li {
					height: 60px;
					float: left;
					font-size: 26px;
					line-height: 60px;
					color: #fef9ef;
					position: relative;

					a {
						display: block;
						color: #fef9ef;
						padding: 0 18px;

						p {
							position: relative;
							z-index: 2;
						}

						&:hover {
							color: #ef7b00;
						}
					}

					&.on {
						a {
							&:hover {
								color: #ffffff;
							}
						}

						&::after {
							width: 100%;
							height: 80px;
							background: #ef7b00;
							border-radius: 0 0 30px 30px;
							position: absolute;
							left: 0;
							top: 0;
							z-index: 0;
							content: " ";
						}
					}
				}
			}
		}
	}
</style>